import { render, staticRenderFns } from "./JflowProcess.vue?vue&type=template&id=f8bcabfa&"
import script from "./JflowProcess.vue?vue&type=script&lang=js&"
export * from "./JflowProcess.vue?vue&type=script&lang=js&"
import style0 from "./JflowProcess.vue?vue&type=style&index=0&id=f8bcabfa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports